export const fontNames = {
  Inconsolata: "Inconsolata",
} as const;

export const supaBigFontSize = "10rem" as const;
export const regular = "1rem" as const;
